import type { Role } from "@/constants/navigation";

export enum DispatcherPermissionValue {
  ChatList = "chat.list",
  SendMessage = "chat.send_message",
  ControlChat = "chat.control",
  TransferBetweenDispatchers = "chat.transfer_between_dispatchers",

  TripMonitorList = "trip_monitor.list",
  CheckCallsEdit = "check_calls.edit",
  CheckCallsList = "check_calls.list",
  BrokerUpdatesEdit = "broker_updates.edit",
  BrokerUpdatesList = "broker_updates.list",

  DispatchersList = "dispatchers.list",
  DispatchersLogs = "dispatchers.logs",
  DispatchersEdit = "dispatchers.edit",
  DispatchersArchive = "dispatchers.archive",

  UsersList = "users.list",
  UsersInfo = "users.info",
  UsersEdit = "users.edit",
  UsersArchive = "users.archive",

  OrdersList = "orders.list",
  OrdersInfo = "orders.info",
  OrdersEdit = "orders.edit",

  TripsEdit = "trips.edit",
  TripsInfo = "trips.info",
  TripsRouteActions = "trips.route_actions",

  CompaniesList = "companies.list",
  CompaniesEdit = "companies.edit",

  TrucksList = "trucks.list",
  TrucksInfo = "trucks.info",
  TrucksEdit = "trucks.edit",
  TrucksReserve = "trucks.reserve",
  TrucksArchive = "trucks.archive",
  TrucksChangeStatus = "trucks.change_status",
  TrucksSearch = "trucks.search",

  ReportsGenerate = "report.generate",
  ReportsList = "report.list",

  MapShowTrucks = "map.show_trucks",
}

export enum DispatcherPermissionName {
  ChatList = "Show chat threads",
  SendMessage = "Send chat messages",
  ControlChat = "Chat control: claim, transfer, resolve",
  TransferBetweenDispatchers = "Transfer chats between dispatchers",

  TripMonitorList = "Show trip monitor",
  CheckCallsEdit = "Check call add/edit",
  CheckCallsList = "Check calls list",
  BrokerUpdatesEdit = "Broker update add/edit",
  BrokerUpdatesList = "Broker updates list",

  DispatchersList = "Show all dispatchers",
  DispatchersLogs = "Dispatchers logs",
  DispatchersEdit = "Dispatcher edit",
  DispatchersArchive = "Archive dispatchers",

  UsersList = "Show all users",
  UsersInfo = "View user info",
  UsersEdit = "Add/edit users",
  UsersArchive = "Archive users",

  OrdersList = "Show all orders",
  OrdersInfo = "View order info",
  OrdersEdit = "Add/edit orders",

  TripsEdit = "Add/edit trips",
  TripsInfo = "View trip info",
  TripsRouteActions = "Process trip route actions",

  CompaniesList = "Show all facilities, customers, brokers",
  CompaniesEdit = "Add/edit facilities, customers, brokers",

  TrucksList = "Show all trucks",
  TrucksInfo = "View truck info",
  TrucksEdit = "Add/edit trucks",
  TrucksReserve = "Reserve truck",
  TrucksArchive = "Trucks archive",
  TrucksChangeStatus = "Change truck status",
  TrucksSearch = "Access to truck search",

  ReportsGenerate = "Generate reports",
  ReportsList = "Access to reports",

  MapShowTrucks = "Map::show trucks",
}

export interface DispatcherPermission {
  name: DispatcherPermissionName;
  value: DispatcherPermissionValue;
}

export interface DispatcherPermissionGroupItem {
  group: DispatcherPermissionGroup;
  permissions: DispatcherPermission[];
}

export enum DispatcherPermissionGroup {
  Chat = "Chat",
  TripMonitor = "Trip Monitor",
  Dispatchers = "Dispatchers",
  Users = "Users",
  Orders = "Orders",
  Trips = "Trips",
  Companies = "Companies",
  Trucks = "Trucks",
  Reports = "Reports",
  Map = "Map",
}

export interface CurrentDispatcher {
  id: number | null;
  name: string | null;
  firstName: string;
  lastName: string;
  roles: Role[];
  phone: string | null;
  phoneExt: string | null;
  timezone: string;
  company: DispatcherCompanyDto;
  isSuperAdmin: boolean;
  allExistingPermissions: DispatcherPermissionGroupItem[];
  permissions: DispatcherPermissionValue[];
  avatar?: string;
}

export interface DispatcherCompanyDto {
  id: number;
  name: string;
  code: string;
}
